import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../msal/auth.service';
import { CommonService } from '../../services/common.service';
import { SearchUpdateConfirmationComponent } from '../search-update-confirmation/search-update-confirmation.component';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, OnChanges {

  public selectedMenu: string = '/portal/personal-info';
  public selectedUrl: string = '/portal/personal-info';
  public teamRoleAssigned: any = '';
  public agentSearchTeamInfo: any = '';
  public teamWebsiteAccountUrl: any = '/portal/team-website/team-website-account'
  public teamWebsiteUrl: any = '/portal/team-website';
  public teamListWebsiteUrl: any = '/portal/team-website/teamlist';
  public showTeamWebsite: boolean = false;
  public isOfficeManagerUser: boolean = false;
  public iSuperAdminUser: boolean = false;
  public iBranchAdminUser: boolean = false;
  @ViewChild('changeMenuModal', { static: true })
  public changeMenuModal: SearchUpdateConfirmationComponent | any;
  @ViewChild('changeTeamWebsiteMenuModal', { static: true })
  public changeTeamWebsiteMenuModal: SearchUpdateConfirmationComponent | any;
  @ViewChild('officeManagerSearchModal', { static: true })
  public officeManagerSearchModal: SearchUpdateConfirmationComponent | any;

  @Input() public isSearchedOfficeManagerUser: any;
  sharePointUrl = '';
  assetsUrl = '';
  @Output() closeSidebarHeader = new EventEmitter<any>();
  public url: string = '';
  public isFMUser: boolean = false;
  @Input() officeManagerAgentSearch: any;
  showTeamWebsiteMenu: boolean = false;
  routeUrl = '';
  isXcelerateRedirect: boolean = false;
  public isDelegateUser: Boolean = false;

  constructor(private router: Router,
    private authService: AuthService,
    private commonSerice: CommonService) {
    // Blank constructor
  }

  ngOnChanges() {
    // blank constructor
  }

  ngOnInit(): void {
    this.isXcelerateRedirect = this.commonSerice.getIsXcelerateRedirect();
    this.sharePointUrl = environment.sharePointUrl;
    this.assetsUrl = environment.assetsUrl;
    this.isOfficeManagerUser = this.commonSerice.isOfficeManagerUser();
    this.iSuperAdminUser = this.commonSerice.isSuperAdminUser();
    this.iBranchAdminUser = this.commonSerice.isBranchAdminUser();
    let userTeamRole = this.commonSerice.getUserTeamRole();
    this.isDelegateUser = this.commonSerice.getIsDelegateLoggedIn();
    this.teamRoleAssigned = userTeamRole;
    if (userTeamRole === 'Leader' || userTeamRole === 'Member') {
      this.showTeamWebsiteMenu = true;
    } else {
      this.showTeamWebsiteMenu = false;
    }
    this.commonSerice.subscribeToFMUser((res: any) => {
      this.isFMUser = res;
    })
    this.authService.subscribeToUrl((url: any) => {
      this.url = url;
    });

    this.commonSerice.subscribeToGetTeamRole((res: any) => {
      
      this.commonSerice.setUserTeamRole(res?.teamRole);
      this.teamRoleAssigned = res?.teamRole;
      if (res?.teamRole === 'Leader' || res?.teamRole === 'Member') {
        this.showTeamWebsiteMenu = true;
      } else {
        this.showTeamWebsiteMenu = false;
      }
    })

    if(sessionStorage.getItem('currentUrl'))
      {
        //this.url = sessionStorage.getItem('currentUrl') as string;  
        this.commonSerice.redirectToNewPage(this.selectedUrl);   
      }
  }


  /**
    * Set Menu flag
    */
  public isMenuSelected(menuName: string): boolean {
    return menuName === this.selectedMenu;
  }

  /**
    *navigate to specific url
    */
  public navigateTo(url: any): void {
    this.selectedUrl = url;
    if (this.selectedUrl.includes('/portal/office-websites') || this.selectedUrl.includes('/portal/leads-crm')   
      || this.selectedUrl.includes('portal/personal-info') || this.selectedUrl.includes('/portal/subscriptions')
      || this.selectedUrl.includes('/portal/website-account') || this.selectedUrl.includes('/portal/website-listing') || this.selectedUrl.includes('/portal/team-website')
      || this.selectedUrl.includes('/portal/office-showcase') || this.selectedUrl.includes('/portal/office-core-service')) {
      this.closeSidebarHeader.emit(true);
    }
    this.commonSerice.redirectToNewPage(this.selectedUrl);
  }

  redirectToNewMenu() {
    this.commonSerice.setFormUpdateStatus(false);
    this.selectedMenu = this.selectedUrl;
    sessionStorage.setItem('activeUrl', this.selectedUrl)
    this.router.navigate([this.selectedUrl]);
  }



  /**
   * On click of team website Menu
   */
  navigateToTeamWebsite() {
    this.selectedUrl = this.teamWebsiteUrl;
    if (this.commonSerice.getFormUpdateStatus()) {
      this.changeTeamWebsiteMenuModal.showModal()
    } else {
      this.navigateToTeamWebsiteConfirm();
    }
  }

  navigateToTeamWebsiteConfirm() {
    this.commonSerice.setFormUpdateStatus(false);
    let teamCountObj = this.commonSerice.getTeamCountObj();
    if (teamCountObj?.teamCount > 1 && teamCountObj.teamId === 0) {
      this.router.navigate([this.teamListWebsiteUrl]);
      this.closeSidebarHeader.emit(true);
    } else {
      this.closeSidebarHeader.emit(true);
      this.selectedMenu = this.teamWebsiteUrl;
      if (this.teamRoleAssigned === "Leader") {
        this.router.navigate([this.teamWebsiteAccountUrl]);
      } else {
        this.router.navigate([this.teamWebsiteUrl]);

      }
    }
  }

  /**
 *Check user role
 */
  public checkUserRole(_userRole: any): boolean {
    return true
  }


  openOfficeManagerSearch() {
    if (this.commonSerice.getFormUpdateStatus()) {
      this.officeManagerSearchModal.showModal()
    } else {
      this.officeManagerSearchConfirm();
    }
    this.closeSidebarHeader.emit(true);
  }

  officeManagerSearchConfirm() {
    this.commonSerice.setOfficeManagerAgentSitesClick(true);
    this.commonSerice.setFormUpdateStatus(false);
    this.router.navigate(['/portal']);
  }

  showMenuForManager() {
    if ((this.iBranchAdminUser || this.iSuperAdminUser || this.isDelegateUser) && this.isSearchedOfficeManagerUser && !this.isXcelerateRedirect) {
      return true;
    } else if (this.isOfficeManagerUser && !this.isXcelerateRedirect) {
      if (this.commonSerice.lastSearchAgentDetails && !this.isSearchedOfficeManagerUser) {
        return false;
      } else if (this.commonSerice.lastSearchAgentDetails && this.isSearchedOfficeManagerUser) {
        return true;
      } else if (!this.commonSerice.lastSearchAgentDetails && this.officeManagerAgentSearch) {
        return true;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }
  showAgentSitesForManager() {
    if (!this.commonSerice.getOfficeManagerAgentSitesClick() && this.isOfficeManagerUser) {
      return true;
    } else {
      return false;
    }
  }

}
